<template>
  <div class="edit-container-form">
    <el-form
      ref="form"
      size="small"
      label-position="top"
      :model="formData"
      :rules="rules"
      :validate-on-rule-change="false"
      class="edit-container-form__body"
    >
      <el-form-item
        class="edit-container-form__section edit-container-form__section--type"
        :label="$l('form_label_containerCode') || '选择柜型'"
        prop="containerCode"
      >
        <container-select
          v-model="formData.containerCode"
          @change="containerChange"
        />
      </el-form-item>

      <el-row
        class="edit-container-form__section edit-container-form__section--type"
        :gutter="12"
      >
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_containerNo') || '集装箱号'"
            style="margin-bottom: 0 !important;"
          >
            <el-input
              v-model.trim="formData.containerNo"
              :placeholder="
                $l('form_placeholder_containerNo') || '请输入集装箱号'
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_sealNo') || '箱封号'"
            style="margin-bottom: 0 !important;"
          >
            <el-input
              v-model.trim="formData.sealNo"
              :placeholder="$l('form_placeholder_sealNo') || '请输入箱封号'"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row class="edit-container-form__section" :gutter="12">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_extendParameterType') || '订舱放大参数'"
            prop="extendParameterType"
          >
            <el-radio-group
              v-model="formData.extendParameterType"
              class="edit-container-form__tabs"
            >
              <el-radio-button label="DEFAULT">
                {{ $l('label_extend_default') || '不指定' }}
              </el-radio-button>
              <el-radio-button label="LWH">
                {{ $l('label_extend_lwh_short') || '放大长宽高' }}
              </el-radio-button>
              <el-radio-button label="VM">
                {{ $l('label_extend_vm_short') || '指定体积' }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row
        v-if="isLWH"
        class="edit-container-form__section edit-container-form__section--compact"
        :gutter="12"
      >
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_extendLength') || '长(cm)'"
            prop="extendParameterLength"
          >
            <el-input-number
              v-model="formData.extendParameterLength"
              controls-position="right"
              :min="0"
              :step="1"
              :precision="2"
              v-el-inputnumber-default0
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_extendWidth') || '宽(cm)'"
            prop="extendParameterWidth"
          >
            <el-input-number
              v-model="formData.extendParameterWidth"
              controls-position="right"
              :min="0"
              :step="1"
              :precision="2"
              v-el-inputnumber-default0
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_extendHeight') || '高(cm)'"
            prop="extendParameterHeight"
          >
            <el-input-number
              v-model="formData.extendParameterHeight"
              controls-position="right"
              :min="0"
              :step="1"
              :precision="2"
              v-el-inputnumber-default0
              style="width:100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row
        v-if="isVM"
        class="edit-container-form__section edit-container-form__section--compact"
        :gutter="12"
      >
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_containerBookingVolume') || '指定体积(m³)'"
            prop="containerBookingVolume"
          >
            <el-input-number
              v-model="formData.containerBookingVolume"
              controls-position="right"
              :min="0"
              :step="1"
              :precision="2"
              v-el-inputnumber-default0
              style="width:100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="confirm()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ContainerSelect from './container-select.vue'

export default {
  components: { ContainerSelect },
  mixins: [EditLoading],
  props: {
    shipmentContainerCode: { type: String, default: '' },
    shipmentCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: { extendParameterType: 'DEFAULT' },
      backDialogVisible: false,
    }
  },
  computed: {
    isLWH() {
      return this.formData.extendParameterType === 'LWH'
    },
    isVM() {
      return this.formData.extendParameterType === 'VM'
    },
    rules() {
      return {
        containerCode: [
          {
            required: true,
            message: this.$l('form_placeholder_containerCode') || '请选择柜型',
            trigger: 'change',
          },
        ],
        extendParameterType: [
          {
            required: true,
            message:
              this.$l('form_placeholder_extendParameterType') ||
              '请选择订舱放大参数',
            trigger: 'change',
          },
        ],
        extendParameterLength: [
          {
            required: this.isLWH,
            message: this.$l('form_placeholder_extendLength') || '请输入长度',
            trigger: ['blur', 'change'],
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$l('tips_length_nonzero') || '长度不能为0'))
                return
              }

              callback()
            },
          },
        ],
        extendParameterWidth: [
          {
            required: this.isLWH,
            message: this.$l('form_placeholder_extendWidth') || '请输入宽度',
            trigger: ['blur', 'change'],
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$l('tips_width_nonzero') || '宽度不能为0'))
                return
              }

              callback()
            },
          },
        ],
        extendParameterHeight: [
          {
            required: this.isLWH,
            message: this.$l('form_placeholder_extendHeight') || '请输入高度',
            trigger: ['blur', 'change'],
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$l('tips_height_nonzero') || '高度不能为0'))
                return
              }

              callback()
            },
          },
        ],
        containerBookingVolume: [
          {
            required: this.isVM,
            message:
              this.$l('form_placeholder_containerBookingVolume') ||
              '请输入指定体积',
            trigger: ['blur', 'change'],
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$l('tips_volume_nonzero') || '体积不能为0'))
                return
              }

              callback()
            },
          },
        ],
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.shipmentContainerCode) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomShipmentContainerDetailApi({
          shipmentContainerCode: this.shipmentContainerCode,
        })
        .catch(() => null)
      this.loadingClose()

      if (!res) return

      this.formData = res.body || {}
    },
    containerChange(opt) {
      this.formData.containerName = opt.label
    },
    async confirm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomShipmentContainerSaveApi({
          ...this.formData,
          shipmentCode: this.shipmentCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, msg } = res
      const error = status !== 200
      this.$message({
        showClose: true,
        message: msg,
        type: error ? 'error' : 'success',
      })
      if (error) return

      this.$emit('reload')
      this.close()
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.edit-container-form {
  &__section {
    margin-bottom: 4px;
  }

  &__section--type {
    margin-bottom: 18px;
    padding-bottom: 18px;
    border-bottom: 1px solid #eef2f7;
  }

  &__section--compact {
    margin-bottom: 0;
  }
}

::v-deep .edit-container-form__body {
  .el-form-item__label {
    font-size: 14px;
    font-weight: 600;
    color: #344054;
  }

  .el-input__inner,
  .el-textarea__inner,
  .el-input-number {
    border-radius: 8px;
  }

  .el-input__inner,
  .el-textarea__inner,
  .el-input-number__decrease,
  .el-input-number__increase,
  .el-input-number__decrease.is-disabled,
  .el-input-number__increase.is-disabled {
    border-color: #d0d5dd;
  }

  .el-input__inner,
  .el-textarea__inner {
    height: 36px;
    color: #101828;
  }

  .el-input__inner::placeholder,
  .el-textarea__inner::placeholder {
    color: #98a2b3;
  }

  .el-input-number {
    width: 100%;
    line-height: 34px;
  }

  .el-input-number .el-input__inner {
    padding-right: 14px;
    text-align: left;
  }

  .el-input-number__decrease,
  .el-input-number__increase {
    display: none;
  }

  .el-radio-group {
    display: inline-flex;
    padding: 4px;
    border-radius: 10px;
    background: #f2f4f7;
  }

  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #409eff;
    background: #fff;
    border-color: transparent;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08);
  }

  .el-radio-button:first-child .el-radio-button__inner,
  .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 8px;
  }

  .el-radio-button__inner {
    min-width: 104px;
    height: 32px;
    padding: 0 16px;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: #667085;
    line-height: 32px;
    box-shadow: none;
  }
}

::v-deep .el-input input[type='number']::-webkit-outer-spin-button,
::v-deep .el-input input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
::v-deep .el-input input[type='number'] {
  -moz-appearance: textfield;
}
</style>
